export default {
  card: {
    title: 'Thanh toán bằng thẻ',
    inputs: {
      number: {
        title: 'Số thẻ',
        placeholder: 'Nhập số thẻ',
      },
    },
  },
  'driver-tips': {
    title: 'Cảm ơn bạn đã<br><span>ủng hộ tài xế!</span>',
    description: '100% tiền boa của bạn sẽ được chuyển trực tiếp đến',
    remember: 'Xin lưu ý, việc để lại tiền boa hoàn toàn là tùy bạn!',
    'confirmation-modal': {
      title: 'Vui lòng xác nhận:',
      description: 'Bạn có chắc muốn gửi tiền boa là',
      error: 'Số tiền boa phải nằm trong khoảng từ $2 đến $40.',
      actions: {
        confirm: 'Xác nhận',
        cancel: 'Hủy',
      },
    },
  },
  'tips-amount': {
    other: 'Khác',
  },
  'tips-component': {
    thanks: 'Cảm ơn bạn! Tiền boa của bạn đã được nhận và chắc chắn sẽ làm ngày của tài xế thêm vui vẻ.',
    more: 'Gửi thêm tiền boa',
  },
  'tips-old': {
    title: 'Cảm ơn bạn đã<br><span>ủng hộ tài xế!</span>',
    description: '100% tiền boa của bạn sẽ được chuyển trực tiếp đến',
    btn: 'Thanh toán bằng thẻ',
  },
}
